var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "posterSettingPanel" }, [
    _c("div", { staticClass: "formItem" }, [_vm._t("default")], 2),
    _vm.setting && _vm.setting.showName
      ? _c("div", { staticClass: "formItem" }, [_vm._t("userName")], 2)
      : _vm._e(),
    _c("div", { staticClass: "formItem" }, [
      _c("div", { staticClass: "formLabel" }, [_vm._v("文字大小")]),
      _c(
        "div",
        { staticClass: "formValue" },
        [
          _c("span", { staticClass: "m-r-12" }, [_vm._v("14")]),
          _c("el-slider", {
            staticClass: "m-r-12",
            staticStyle: { width: "180px" },
            attrs: { min: 14, max: 28, step: 1 },
            model: {
              value: _vm.form.fontSize,
              callback: function ($$v) {
                _vm.$set(_vm.form, "fontSize", $$v)
              },
              expression: "form.fontSize",
            },
          }),
          _c("span", [_vm._v("28")]),
          _c(
            "span",
            {
              staticClass: "m-l-10 cfontWeight",
              style: {
                "font-weight": _vm.form.fontWeight,
                opacity: _vm.setting && _vm.setting.showFontWeight ? 1 : 0,
              },
              on: { click: _vm.onhandleClickFontWeight },
            },
            [_vm._v("加粗")]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "formItem" }, [
      _c("div", { staticClass: "formLabel" }, [_vm._v("文字颜色")]),
      _c(
        "div",
        { staticClass: "formValue" },
        [
          _c("el-color-picker", {
            model: {
              value: _vm.form.color,
              callback: function ($$v) {
                _vm.$set(_vm.form, "color", $$v)
              },
              expression: "form.color",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }